export default __webpack_public_path__ + "static/media/dashboard-bulk-transaction-icon.75939308.svg";